import styled from "styled-components";

export const ContainerPage = styled.main`
  width: 100%;
  height: 100%;
`;

export const ContainerHome = styled.main`
  width: 100%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: ${({ theme }) => theme.homeBackground};
  background-size: cover;
  background-position: center center;
`;

export const ButtonCall = styled.div`
  width: 100%;
  height: 100vh;
  margin-left: 300px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  button {
    background-color: ${({ theme }) => theme.homeButtonBackground};
    border: 1px solid ${({ theme }) => theme.homeButtonBorder};
    border-radius: 5px;
    padding: 40px 40px;

    font: 700 3rem "Nunito", sans-serif;
    color: ${({ theme }) => theme.homeButtonText};

    cursor: pointer;

    &:hover {
      transition: all 1s;
      filter: brightness(0.8);
    }

    &:active {
      transform: translateY(4px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
    }
  }

  @media (max-width: 900px) {
    transition: 1.8s all;
    justify-content: center;
    margin: 0;
    padding: 20px;
  }

  @media (max-width: 665px) {
    transition: 1.8s all;
    button {
      font-size: 2rem;
    }
  }

  @media (max-width: 490px) {
    button {
      font-size: 1.5rem;
    }
  }

  @media (max-width: 400px) {
    button {
      font-size: 1.2rem;
    }
  }

  @media (max-width: 340px) {
    button {
      font-size: 1rem;
    }
  }
`;
